import axios from '../../localAxios';
import { WorkspaceRole } from '../getWorkspaceMembers';
import { workspaceCodeURL } from '../workspacesURLs';

interface Code {
  code: string;
}

interface ActivateWorkspaceCodeParams {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export async function activateWorkspaceCode({
  workspaceId,
  workspaceRole,
}: ActivateWorkspaceCodeParams) {
  const url = workspaceCodeURL({
    workspaceId: workspaceId,
    workspaceRole: workspaceRole,
  });
  const response = await axios.post<Code>(
    url.href,
    {
      role: workspaceRole,
    },
    {
      withCredentials: true,
    }
  );
  return response.data;
}
